import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { KpiService } from 'src/app/service/kpi.service';
import { ExcelService } from 'src/app/service/excel.service';
import { PeriodsService } from 'src/app/service/periods.service';
import { BoardsService } from 'src/app/service/boards.service';
@Component({
	selector: 'app-kpis',
	templateUrl: './kpis.component.html',
	styleUrls: ['./kpis.component.scss'],
	standalone: false,  // NOSONAR
})
export class KpisComponent implements OnInit {
	successMessage = '';
	errorMessage = '';
	currentPageNo: any;
	currentPageBoolean: boolean = false;
	totalPage: any;
	currentPageForTotalPage: any;
	isLastPageFound: any;
	page = '';
	rowCount;
	columnDefs;
	rowData;
	icons;
	gridApi: any;
	gridColumnApi: any
	defaultColDef;
	paginationPageSize: number = 30;
	context: any;
	setPagination = 'true';
	// @ViewChild('agGrid', { static: true }) agGrid
	@ViewChild('agGrid') agGrid;
	enableByRegionGrid: boolean = false;
	enableByTaskGrid: boolean = false;
	enableLateReasonGrid: boolean = false;
	lateReasonJson;
	Customer;
	displayTable = [];
	secondDisplayTable = [];
	backendArray;
	stylingClass;
	backendArray2;
	regionID;
	regionID1;
	regionID2;
	// byRegionPeriod:number = 1;
	byRegionPeriod;
	byTaskFromPeriod;
	byTaskToPeriod;
	byLateReasonFromPeriod;
	byLateReasonToPeriod;
	periodData;
	totalTasks;
	lateTasks;
	otherReasons;
	temp;
	dynamicHeight: number;
	dynamicHeightTable: number;
	dynamicHeightCard: number;
	forgotMask = 'FORGOT TO MARK';
	completedOntime = 'COMPLETED ON TIME';
	totalRecords = 0; // Replace with your actual total records count
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 30;
	endRecord = 0;
	pgDropDown = [
		{ value: 5, selected: false },
		{ value: 10, selected: false },
		{ value: 20, selected: false },
		{ value: 30, selected: true },
		{ value: 50, selected: false },
	]
	constructor(private readonly kpiService: KpiService, private readonly ngxUiLoaderService: NgxUiLoaderService,
		private readonly excelService: ExcelService, private readonly periodService: PeriodsService,
		private readonly boardService: BoardsService) {
		this.dynamicHeight = 0.665 * (window.innerHeight);
		this.dynamicHeightCard = 0.665 * (window.innerHeight);
		this.dynamicHeightTable = 0.6 * (window.innerHeight);
		// booting up the ag grid
		this.context = {
			componentParent: this
		};
		this.icons = {
			sortUnSort: '<i class="fa fa-sort" style="font-weight:bold;color:black;"/>',
		};
		this.defaultColDef = {
			minWidth: 100,
			floatingFilter: true,
			wrapText: true
		};
	}
	sizeToFit() { this.gridApi.sizeColumnsToFit(); }
	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }
	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }
	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }
	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }
	onPageSizeChanged(event: any) { this.gridApi.paginationSetPageSize(Number(event.target.value)); this.updatePaginationDetails(); }
	getCurrentPage(): boolean {
		this.currentPageNo = this.agGrid?.api.paginationGetCurrentPage();
		if (this.currentPageNo == 0) { // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}
	isLastPage(): boolean {
		this.totalPage = Number(this.agGrid?.api.paginationGetTotalPages());
		this.currentPageForTotalPage = Number(this.agGrid?.api.paginationGetCurrentPage()) + 1;
		if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}
	rppChanged(event: any) {
		this.cPage = 1;
		this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}
	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();
			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}
	onGridReady(params: any) {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;
		this.gridApi.sizeColumnsToFit();
	}
	ngOnInit(): void {
		// clear contingency data
		sessionStorage.removeItem('contData');
		this.boardService.deleteContingenyList().subscribe(_result => {
			// contingency list deleted
		});
		// on load 
		this.page = "By Region";
		this.display();
	}
	display() {
		//fetching periods list from backend - common to all three options
		this.ngxUiLoaderService.start("loader-01");
		//fetch from local-storage
		this.temp = localStorage.getItem('period-data');
		if (this.temp) {
			this.periodData = JSON.parse(this.temp);
			this.byRegionPeriod = parseInt(this.periodData[0].periodId);
			this.byTaskFromPeriod = parseInt(this.periodData[0].periodId);
			this.byTaskToPeriod = parseInt(this.periodData[1].periodId);
			this.byLateReasonFromPeriod = parseInt(this.periodData[0].periodId);
			this.byLateReasonToPeriod = parseInt(this.periodData[1].periodId);
		}
		else {
			setTimeout(() => {
				this.successMessage = '';
				this.errorMessage = '';
			}, 6500);
			this.ngxUiLoaderService.stop("loader-01");
		}
		setTimeout(() => {
			this.displayTableContent();
		}, 1000);
	}
	displayTableContent() {
		console.info("page", this.page);
		if (this.page) {
			this.rowCount = '';
			if (this.page == "By Region") { // NOSONAR
				this.enableByRegionGrid = true;
				this.enableByTaskGrid = false;
				this.enableLateReasonGrid = false;
				this.columnDefs = this.getcoloumDefs()
				this.ngxUiLoaderService.start("loader-01");
				//API Integration
				this.rowData = [];
				const tempArray = [];
				console.info("the selected period id", this.byRegionPeriod);
				this.kpiService.getByRegionDetails(this.byRegionPeriod).subscribe(result => {
					if (result?.length > 0) {
						let obj;
						result.forEach(rowArray => {
							// replace rowArray[0]
							// round off to two decimal places
							obj = {
								"region": rowArray.region, "ctime": rowArray.completed,
								"cper": (rowArray.completedPer * 100).toFixed(2) + "%", "ftime": rowArray.forgot,
								"fper": (rowArray.forgotPer * 100).toFixed(2) + "%",
								"late": rowArray.late, "lper": (rowArray.latePer * 100).toFixed(2) + "%",
								"open": rowArray.open, "oper": (rowArray.openPer * 100).toFixed(2) + "%", "total": rowArray.total_tasks
							};
							tempArray.push(obj);
						});
						this.rowData = tempArray;
						if (this.rowData.length) {
							this.totalRecords = this.rowData.length;
							this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
							this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
							this.sRecord = 1
							this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
							if (this.cPage > this.tPage) {
								this.cPage = 1;
							}
						}
						this.rowCount = this.rowData.length;
					}
					else {
						setTimeout(() => {
							this.successMessage = '';
							this.errorMessage = '';
						}, 6500);
					}
					this.ngxUiLoaderService.stop("loader-01");
				});
			}
			else if (this.page == "By Task") { // NOSONAR
				this.enableByTaskGrid = true;
				this.enableByRegionGrid = false;
				this.enableLateReasonGrid = false;
				this.columnDefs = [
					{
						headerName: "TASK", headerClass: "task", field: "task", cellClass: "cell_task", width: 360,
						suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true,
						floatingFilterComponentParams: { suppressFilterButton: true },
						filter: 'agTextColumnFilter',
						autoHeight: true, unSortIcon: true
					},
					{
						headerName: this.completedOntime, headerClass: "rctime", field: "rctime", cellClass: "cell_ctime",
						width: 100, headerHeight: 100, autoHeight: true, unSortIcon: true
					},
					{
						headerName: "", headerClass: "rcper", field: "rcper", cellClass: "cper", width: 100,
						autoHeight: true, sortable: true, unSortIcon: true
					},
					{
						headerName: this.forgotMask, headerClass: "rftime", field: "rftime", cellClass: "cell_ftime",
						width: 100, autoHeight: true, unSortIcon: true
					},
					{
						headerName: "", headerClass: "rfper", field: "rfper", cellClass: "cell_fper", width: 100,
						autoHeight: true, sortable: true, unSortIcon: true
					},
					{
						headerName: "LATE", headerClass: "rlate", field: "rlate", cellClass: "cell_late", width: 100, autoHeight: true, unSortIcon: true
					},
					{
						headerName: "", headerClass: "rlper", field: "rlper", cellClass: "cell_lper", width: 100,
						autoHeight: true, sortable: true, unSortIcon: true
					},
					{
						headerName: "OPEN", headerClass: "ropen", field: "ropen", cellClass: "cell_open", width: 100, autoHeight: true, unSortIcon: true
					},
					{
						headerName: "", headerClass: "roper", field: "roper", cellClass: "oper", width: 100,
						autoHeight: true, sortable: true, unSortIcon: true
					},
					{
						headerName: "TOTAL", headerClass: "rtotal", field: "rtotal", cellClass: "cell_total", width: 100, autoHeight: true, flex: 1, unSortIcon: true
					}
				];
				//API Integration
				this.rowData = [];
				const tempArray = [];
				console.info("the selected period id - task", this.byTaskFromPeriod, this.byTaskToPeriod);
				this.kpiService.getByTaskDetails(this.byTaskFromPeriod, this.byTaskToPeriod).subscribe(result => {
					if (result?.length > 0) {
						let obj;
						result.forEach(rowArray => {
							obj = {
								"task": rowArray.task, "rctime": rowArray.completed,
								"rcper": (rowArray.completedPer * 100).toFixed(2) + "%", "rftime": rowArray.forgot,
								"rfper": (rowArray.forgotPer * 100).toFixed(2) + "%",
								"rlate": rowArray.late, "rlper": (rowArray.latePer * 100).toFixed(2) + "%",
								"ropen": rowArray.open, "roper": (rowArray.openPer * 100).toFixed(2) + "%", "rtotal": rowArray.total_tasks
							};
							tempArray.push(obj);
						});
						this.rowData = tempArray;
						if (this.rowData.length) {
							this.totalRecords = this.rowData.length;
							this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
							this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
							this.sRecord = 1
							this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
							if (this.cPage > this.tPage) {
								this.cPage = 1;
							}
						}
						this.rowCount = this.rowData.length;
					}
					else {
						setTimeout(() => {
							this.successMessage = '';
							this.errorMessage = '';
						}, 6500);
					}
					this.ngxUiLoaderService.stop("loader-01");
				});
			}
			else if (this.page == "By Late Reason") { // NOSONAR
				this.ngxUiLoaderService.start("loader-01");
				//API Integration
				this.backendArray = [];
				this.displayTable = [];
				this.kpiService.getByLateReasonDetails(this.byLateReasonFromPeriod, this.byLateReasonToPeriod).subscribe(result => {
					if (result?.length > 0) {
						this.backendArray = result;
						this.kpiService.getLateReasonTotal(this.byLateReasonFromPeriod, this.byLateReasonToPeriod).subscribe(result => {
							if (result.length > 0) {
								if (result[0].totalTasks == null) { // NOSONAR
									this.totalTasks = 0;
								} else {
									this.totalTasks = result[0].totalTasks;
								}
								if (result[0].totalLateTasks == null) { // NOSONAR
									this.lateTasks = 0;
								} else {
									this.lateTasks = result[0].totalLateTasks;
								}
								this.ngxUiLoaderService.stop("loader-01");
							}
							else {
								setTimeout(() => {
									this.successMessage = '';
									this.errorMessage = '';
								}, 6500);
								this.ngxUiLoaderService.stop("loader-01");
							}
						});
						this.backendArray.filter(x => x.tier == 1).forEach(e => { // NOSONAR
							const tire1ID = e.late_reason_Id;
							e.per1 = e.percentage.toFixed(2) + "%";
							e.class = "tier1";
							e.descClass = "tierDesc1";
							this.displayTable.push(e);
							this.stylingClass = "tier1";
							this.backendArray.filter(x => x.tier == 2 && x.parent_Id == tire1ID).forEach(e => { // NOSONAR
								const tire2ID = e.late_reason_Id;
								e.per2 = e.percentage.toFixed(2) + "%";
								e.class = "tier2";
								e.descClass = "tierDesc2";
								this.displayTable.push(e);
								this.stylingClass = "tier2";
								this.backendArray.filter(x => x.tier == 3 && x.parent_Id == tire2ID).forEach(e => { // NOSONAR
									e.per3 = e.percentage.toFixed(2) + "%";
									e.class = "tier3";
									e.descClass = "tierDesc3";
									this.displayTable.push(e);
									this.stylingClass = "tier3";
								});
							});
						});
					}
					else {
						this.totalTasks = 0;
						this.lateTasks = 0;
						setTimeout(() => {
							this.successMessage = '';
							this.errorMessage = '';
						}, 6500);
						this.ngxUiLoaderService.stop("loader-01");
					}
				});
				//API Integration
				this.secondDisplayTable = [];
				this.backendArray2 = [];
				this.kpiService.getByOtherReasonDetails(this.byLateReasonFromPeriod, this.byLateReasonToPeriod).subscribe(result => {
					console.info("the result", result);
					if (result?.length > 0) {
						this.backendArray2 = result;
						this.kpiService.getOtherReasonTotal(this.byLateReasonFromPeriod, this.byLateReasonToPeriod).subscribe(result => {
							if (result?.length > 0) {
								if (result[0].totalOtherTasks == null) {
									this.otherReasons = 0;
								} else {
									this.otherReasons = result[0].totalOtherTasks;
								}
							}
							else {
								setTimeout(() => {
									this.successMessage = '';
									this.errorMessage = '';
								}, 6500);
							}
						});
						this.backendArray2.filter(x => x.tier == 1).forEach(e => { // NOSONAR
							const tire1ID = e.late_reason_Id;
							e.class = "name1";
							e.descClass = "tierDesc1";
							this.secondDisplayTable.push(e);
							this.stylingClass = "name1";
							console.info("parent id 1", tire1ID);
							this.backendArray2.filter(x => x.tier == 2 && x.parent_Id == tire1ID).forEach(e => { // NOSONAR
								const tire2ID = e.late_reason_Id;
								e.class = "name2";
								e.descClass = "tierDesc2";
								this.secondDisplayTable.push(e);
								this.stylingClass = "name2";
								console.info("parent id 2", tire2ID);
								this.backendArray2.filter(x => x.tier == 3 && x.parent_Id == tire2ID).forEach(e => { // NOSONAR
									e.class = "name3";
									e.descClass = "tierDesc3";
									console.info("inside tier 3");
									this.secondDisplayTable.push(e);
									this.stylingClass = "name3";
								});
							});
						});
					}
					else {
						this.otherReasons = 0;
						setTimeout(() => {
							this.successMessage = '';
							this.errorMessage = '';
						}, 6500);
						this.ngxUiLoaderService.stop("loader-01");
					}
				});
				this.enableLateReasonGrid = true;
				this.enableByTaskGrid = false;
				this.enableByRegionGrid = false;
				//stop load after service call
			}
		}
		//close
	}
	getcoloumDefs() {
		const header = [
			{
				headerName: "REGION", headerClass: "region", field: "region", cellClass: "cell_region",
				width: 130, autoHeight: true
			},
			{
				headerName: this.completedOntime, headerClass: "ctime", field: "ctime", cellClass: "cell_ctime",
				width: 180, autoHeight: true
			},
			{
				headerName: "", headerClass: "cper", field: "cper", cellClass: "cper", width: 100,
				autoHeight: true, sortable: true, unSortIcon: true
			},
			{
				headerName: this.forgotMask, headerClass: "ftime", field: "ftime", cellClass: "cell_ftime",
				width: 150, autoHeight: true
			},
			{
				headerName: "", headerClass: "fper", field: "fper", cellClass: "fper", width: 100,
				autoHeight: true, sortable: true, unSortIcon: true
			},
			{
				headerName: "LATE", headerClass: "late", field: "late", cellClass: "cell_late", width: 135, autoHeight: true
			},
			{
				headerName: "", headerClass: "lper", field: "lper", cellClass: "lper", width: 100,
				autoHeight: true, sortable: true, unSortIcon: true
			},
			{
				headerName: "OPEN", headerClass: "open", field: "open", cellClass: "cell_open", width: 135, autoHeight: true
			},
			{
				headerName: "", headerClass: "oper", field: "oper", cellClass: "oper", width: 100,
				autoHeight: true, sortable: true, unSortIcon: true
			},
			{
				headerName: "TOTAL", headerClass: "total", field: "total", cellClass: "cell_total", width: 135, autoHeight: true, flex: 1,
			}
		];
		return header
	}
	/*Exports all data in XLSX format */
	onBtExport() {
		if (this.enableByRegionGrid) {
			if (this.rowData.length > 0) {
				const exportData = [];
				this.rowData.forEach(e => {
					const obj = {
						region: e.region,
						ctime: e.ctime,
						cper: e.cper,
						ftime: e.ftime,
						fper: e.fper,
						late: e.late,
						lper: e.lper,
						open: e.open,
						oper: e.oper,
						total: e.total
					};
					exportData.push(obj);
				});
				const headers = ['Region', this.completedOntime, '%', this.forgotMask, '%',
					'Late', '%', 'Open', '%', 'Total'];
				this.excelService.exportAsExcelFile(exportData, 'KPI_By_Region', headers);
			}
		}
		else if (this.enableByTaskGrid) {
			if (this.rowData.length > 0) {
				const exportData = [];
				this.rowData.forEach(e => {
					const obj = {
						task: e.task,
						rctime: e.rctime,
						rcper: e.rcper,
						rftime: e.rftime,
						rfper: e.rfper,
						rlate: e.rlate,
						rlper: e.rlper,
						ropen: e.ropen,
						roper: e.roper,
						rtotal: e.rtotal
					};
					exportData.push(obj);
				});
				const headers = ['Task', this.completedOntime, '%', this.forgotMask, '%',
					'Late', '%', 'Open', '%', 'Total'];
				this.excelService.exportAsExcelFile(exportData, 'KPI_By_Task', headers);
			}
		}
	}
	refreshData() {
		this.displayTableContent();
	}
}